import { gql } from '@apollo/client';

export const USER_NOTIFICATION_SUBSCRIPTION = gql`
  subscription userNotification {
    notification__user {
      payload {
        type
        data {
          args
          entity
          message
        }
      }
      type
    }
  }
`;
